async function run(action, times = 1) {
  let success = false;
  let iterations = 0;
  while (success === false && iterations < times) {
    try {
      iterations++;
      await action();
      success = true;
    } catch (e) {
      await sleep(300);
    }
  }
}
function sleep(ms = 0) {
  return new Promise((r) => setTimeout(r, ms));
}
export {
  run as default
};
//# sourceMappingURL=retry.js.map
